export default __webpack_public_path__ + "images/HK_Bild_AdobeStock_116977445.webp?a2dd6980b36db3d7e0afbbda343b2d08";